import React from 'react'
import './EnquiryFormComponent.css'

import Common_Enquiry_Form from '../../Common_Component/Common_Enquiry_Form/Common_Enquiry_Form';

const EnquiryFormComponent = () => {

    

    return (
        <section className='EnquiryFormComponent'>
            <div className='container-fluid p-0'>
                <div className='content_holder'>

                    <div className='img_holder'>
                        <img src='assets\Image\aboutus\enquiry_form\bg_img.png' className='bg_img' />
                    </div>

                    <div className='main_form_holder'>
                        <Common_Enquiry_Form />
                    </div>

                </div>
            </div>


        </section>
    )
}

export default EnquiryFormComponent
